export const paths = {
  base: "/console",
  support: {
    path: "/catalog/support",
    getHref: () => "/catalog/support",
  },
  auth: {
    login: {
      path: "/auth",
      getHref: (redirectTo?: string | null | undefined) =>
        `/auth${redirectTo ? `?r=${encodeURIComponent(redirectTo)}` : ""}`,
    },
    signIn: {
      path: "/auth",
      getHref: () => "/auth",
    },
    signUp: {
      path: "/auth/register",
      getHref: () => "/auth/register",
    },
  },
} as const;

export const apiPaths = {
  auth: {
    countries: {
      path: "/countries",
      getPath: () => "/countries",
    },
  },
  datasets: {
    getDatasets: {
      path: "/datasets",
      getPath: () => "/datasets",
    },
  },
  support: {
    sendEnterpriseContactMessage: {
      path: "/contact-enterprise",
      getPath: () => "/contact-enterprise",
    },
  },
  asknexus: {
    disclaimer: {
      path: "/global-metadata/ASKNEXUS_DISCLAIMER",
      getPath: () => "/global-metadata/ASKNEXUS_DISCLAIMER",
    },
  },
  plans: {
    getPlans: {
      path: "/plans",
      getPath: () => "/plans",
    },
  },
} as const;
